<template>
    <div class="uk-panel uk-panel-box uk-panel-awards">
        <h3 class="uk-panel-title">Awards</h3>

        <ul class="uk-list uk-list-line">
            <li
                v-for="term in terms()"
                :key="term.id"
            >
                <div class="uk-grid uk-grid-small">
                    <div class="uk-width-9-10">
                        <a href @click.prevent="program_edit(term)">{{ term.name }}</a>
                    </div>
                    <div class="uk-width-1-10 uk-text-right">
                        <base-button
                            color="danger"
                            size="mini"
                            @click.prevent.stop="program_remove(term)"
                        >
                            <open-icon glyph="trash" />
                        </base-button>
                    </div>
                </div>
            </li>
            <li>
                <form class="uk-form uk-grid uk-grid-small">
                    <div class="uk-width-9-10">
                        <form-input
                            id="new_award_program"
                            name="name"
                            v-model="program.name"
                            placeholder="New Award Program's Name"
                            :editable="true"
                            :required="false"
                            class="uk-width-1-1"
                        />
                    </div>
                    <div class="uk-width-1-10">
                        <base-button
                            color="primary"
                            @click.prevent="program_add"
                        >
                            <open-icon glyph="plus" />
                        </base-button>
                    </div>
                </form>
            </li>
        </ul>

        <modal-dialog
            id="award-editor"
            :show.sync="editing_program"
        >
            <template v-slot:title>
                Award Program Editor
            </template>

            <form @submit.prevent.stop class="uk-form">
                <award-term-editor
                    :term="editor_program"
                    @input="term_save(editor_program, ...arguments)"
                    @remove="program_remove"
                />
                <h4>Awards</h4>
                <ul class="uk-list uk-list-line">
                    <li
                        v-for="term in terms(editor_program.id)"
                        :key="term.id"
                    >
                        <award-term-editor
                            :term="term"
                            @remove="award_remove"
                        />
                        <!--
                        <div class="uk-grid uk-grid-small">
                            <div class="uk-width-2-10"></div>
                            <div class="uk-width-8-10">
                                <h5>Misc / Sub-Categories</h5>
                                <ul class="uk-list">
                                    <li
                                        v-for="subterm in terms(term.id)"
                                        :key="subterm.id"
                                        class="uk-margin-small-bottom"
                                    >
                                        <div class="uk-grid uk-grid-small">
                                            <div class="uk-width-9-10">
                                                <form-input
                                                    :id="`sub-category-${term.id}-${subterm.id}`"
                                                    name="name"
                                                    v-model="subterm.name"
                                                    :editable="true"
                                                    :required="false"
                                                    class="uk-width-1-1"
                                                    @input="term_save(subterm, ...arguments)"
                                                />
                                            </div>
                                            <div class="uk-width-1-10 uk-text-right">
                                                <base-button
                                                    color="danger"
                                                    @click.prevent.stop="subterm_remove(subterm)"
                                                >
                                                    <open-icon glyph="trash" />
                                                </base-button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <form class="uk-form uk-grid uk-grid-small">
                                            <div class="uk-width-9-10">
                                                <form-input
                                                    id="new_subtype"
                                                    name="name"
                                                    :value="award_subtype_shell_record(term).name"
                                                    :placeholder="`New Sub-Category for ${term.name}`"
                                                    :editable="true"
                                                    :required="false"
                                                    class="uk-width-1-1"
                                                    @input="award_subtype_shell_record(term).name = $event"
                                                />
                                            </div>
                                            <div class="uk-width-1-10">
                                                <base-button
                                                    color="primary"
                                                    @click.prevent="award_subtype_add(term)"
                                                >
                                                    <open-icon glyph="plus" />
                                                </base-button>
                                            </div>
                                        </form>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        //-->
                    </li>
                    <li>
                        <form class="uk-form uk-grid uk-grid-small">
                            <div class="uk-width-9-10">
                                <form-input
                                    id="new_award"
                                    name="name"
                                    v-model="award.name"
                                    placeholder="New Award's Name"
                                    :editable="true"
                                    :required="false"
                                    class="uk-width-1-1"
                                />
                            </div>
                            <div class="uk-width-1-10">
                                <base-button
                                    color="primary"
                                    @click.prevent="award_add"
                                >
                                    <open-icon glyph="plus" />
                                </base-button>
                            </div>
                        </form>
                    </li>
                </ul>
            </form>
        </modal-dialog>
    </div>
</template>

<script>
import is_remote_data_table_source from "../../mixins/IsRemoteDataTableSource"
import handles_saving from "../../mixins/HandlesSaving"

import ModalDialog from "../../dialogs/ModalDialog/ModalDialog"
import FormInput from "../../ui/FormInput"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"
import AwardTermEditor from "./AwardTermEditor"

export default {
    name: "Awards",
    mixins: [is_remote_data_table_source, handles_saving],
    components: {
        ModalDialog,
        FormInput,
        BaseButton,
        OpenIcon,
        AwardTermEditor
    },
    mounted () {
        this.$store.dispatch("FETCH_RECORDS", {
            entity: "term",
            query: { dictionary_id: "awards", archived: true, fields: ["fieldset::default", "in_use"] }
        })
    },
    methods: {
        terms (parent_id = 0) {
            return this.rows.filter(term => term.parent_id === parent_id)
        },
        program_edit (program) {
            this.editor_program = program
            this.editing_program = true
        },
        term_add (term, parent_id = 0) {
            return this.$store.dispatch("CREATE_RECORD", {
                entity: "term",
                data: { dictionary_id: "awards", parent_id, ...term }
            }).then(term => {
                this.current_records_ids.push(term.id)
                this.set_state_values({
                    total: this.state.total + 1,
                    found: this.state.found + 1 || 0
                })
            })
        },
        program_add () {
            if(!this.program || !this.program.name) this.$error("Please enter a program name!")
            else {
                this.term_add(this.program).then(term => {
                    this.program.name = ""
                    this.program_edit(term)
                })
            }
        },
        award_add () {
            if(!this.editor_program || !this.editor_program.id) return
            if(!this.award || !this.award.name) this.$error("Please enter an award name!")
            else {
                this.term_add(this.award, this.editor_program.id).then(() => {
                    this.award.name = ""
                })
            }
        },
        /*
        award_subtype_shell_record (award) {
            if(!this.award_subtypes[award.id]) this.$set(this.award_subtypes, award.id, { name: "" })
            return this.award_subtypes[award.id]
        },
        award_subtype_add (award) {
            if(!award || !award.id) return
            const subtype = this.award_subtype_shell_record(award)
            if(!subtype || !subtype.name) this.$error("Please enter a sub-category name!");
            else {
                this.term_add(subtype, award.id).then(() => {
                    subtype.name = ""
                })
            }
        },
        */
        term_remove (term, title, message) {
            this.$confirm({
                type: "warning",
                title,
                message,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch("RECORD_DELETE", {
                            entity: "term",
                            id: term.id
                        }).then(() => {
                            const index = this.current_records_ids.indexOf(term.id)
                            if(index >= 0) {
                                this.current_records_ids.splice(index, 1)
                                this.set_state_values({
                                    total: this.state.total - 1,
                                    found: this.state.found - 1 || 0
                                })
                            }
                        }).catch(error => {
                            this.$error(error.message)
                        })
                    }
                }
            })
        },
        program_remove (term) {
            this.term_remove(
                term,
                "Delete Award Program",
                `Do you really want to delete ${term.name}? This will delete all associated awards and sub-categories...`
            )
        },
        award_remove (term) {
            this.term_remove(
                term,
                "Delete Award",
                `Do you really want to delete ${term.name}? This will delete all associated sub-categories...`
            )
        },
        /*
        subterm_remove (term) {
            this.term_remove(
                term,
                "Delete Award Sub-Category",
                `Do you really want to delete ${term.name}? There is no undo...`
            )
        },
        */
        term_save (term, value, field) {
            term[field] = value
            this.save_field_for_record_id("term", term.id, value, field)
        }
    },
    computed: {
        state_identifier () {
            return "settings-awards"
        }
    },
    data () {
        return {
            entity: "term",
            default_state: {
                per_page: 0,
                page: 1,
                sort_by: "name",
                sort_dir: "asc",
                filter_on: "dictionary_id",
                filter: "awards",
                archived: true,
                search: "",
                total: 0,
                found: 0,
                context: "dashboard",
                activated_at: 0
            },

            program: { name: "" },
            award: { name: "" },
            award_subtypes: {},

            editor_program: {},
            editing_program: false
        }
    }
}
</script>
